import { render, staticRenderFns } from "./order-service.vue?vue&type=template&id=30f92c8f&scoped=true&"
import script from "./order-service.vue?vue&type=script&lang=js&"
export * from "./order-service.vue?vue&type=script&lang=js&"
import style0 from "./order-service.vue?vue&type=style&index=0&id=30f92c8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f92c8f",
  null
  
)

export default component.exports